import React from 'react';
import {useParams} from 'react-router-dom';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import type {InstanceFormViewType} from '../Shared/InstanceForm';
import InstanceForm from '../Shared/InstanceForm';
import {instanceDocumentTitle} from '../instanceHelpers';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const ViewInstancePage: React.FC = () => {
  useSetDocumentTitle(instanceDocumentTitle);
  const {id, view} = useParams();

  return (
    <ContentWrapper>
      <InstanceForm
        id={Number(id)}
        mode="view"
        view={view as InstanceFormViewType}
      />
    </ContentWrapper>
  );
};

export default ViewInstancePage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.InstancesView(':id', ':view'),
  element: <ViewInstancePage />,
  isPrivate: true,
  requireSuperAdmin: true,
});
